import React from 'react';
import { Location } from '../../assets/icons';
import './PropertyMarket.scss';
import { useSelector } from 'react-redux';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const PropertyMarket = (props) => {
  const { data } = useSelector((state) => state.propertyDetails);

  return (
    <div className='py-64 property-market'>
      <p className='mb-32 fz-24 fw-700 lh-13'>The Realbricks Market</p>
      {/* TODO:Have to update once location is avaialble from API */}
      <p className='fw-600 fz-18 mb-16'>{data?.data?.marketName}</p>
      <div className='fz-16 mb-32'>{data?.data?.marketDesc}</div>
      <div className='d-flex fz-16 text-terracotta fw-600 address'>
        <Location marginRight='4px' />
        {data?.data?.address}
      </div>
      {/* <iframe className='mb-32 map' title='location' src={props.mapLink} loading='lazy' referrerPolicy='no-referrer-when-downgrade' /> */}
      <LazyLoadImage className='mb-32 map' src={data?.data?.mapImage} loading='lazy' alt={data?.data?.address || 'map'} />
      {/* {props.grade && data?.data?.propertyTypeName === PROPERTY_SUB_TYPE.VACATION && (
        <>
          <p className='fw-600 fz-18 mb-0'>Market Grade</p>
          <p className='fz-12 mb-24 text-taupe-80'>
            Data provided by{' '}
            <a href='https://www.airdna.co/' className='text-terracotta underline'>
              AirDNA
            </a>
          </p>
          <div className='performance'>
            <div className='grade'>
              <div className='grade__score'>
                <span className='grade__score__letter'>{props.grade}</span>
                <span className='grade__score__number'>{props.score} of 100</span>
              </div>
              <p className='mb-0 fz-12'>
                Score is calculated by comparing this market’s performance vs. the Top 2000 Global AirBnb markets.{' '}
                <a className='text-terracotta underline' href='/not-found/'>
                  Learn more
                </a>
              </p>
            </div>
            <div className='parameter-list'>
              {props.parameters?.map((data, index) => {
                return (
                  <div className='parameter-list__item' key={index}>
                    <Tooltip title={data.tooltip}>
                      <span className={data.tooltip ? 'parameter-list__item__label tooltip' : 'parameter-list__item__label'}>
                        {data.label} {data.tooltip && <Info marginLeft='8px' />}
                      </span>
                    </Tooltip>
                    <span className='parameter-list__item__value'>{data.value}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </>
      )} */}
    </div>
  );
};

export default PropertyMarket;
